<div class="raptor-banner-footer form-row margin-bottom-xlarge" *ngFor="let banner of data">
  <div class="raptor-section-container grid">
    <div class="raptor-banner-footer-cell cell cell-small-col-span-6 cell-large-col-span-10 cell-large-col-start-2 flex padding-medium margin-horizontal-small">
      <div class="margin-right-small" *ngIf="banner.icon">
        <open-svg-icon [name]="banner.icon" class="small"></open-svg-icon>
      </div>
      <div class="margin-right-small" *ngIf="banner.image">
        <img [src]="banner.image.src" [title]="banner.image.title"/>
      </div>
      <div class="flex flex-column flex-justify-center" [innerHTML]="banner.content"></div>
    </div>
  </div>
</div>
<!-- this compensates for the change of the preceeding div's class from padding-bottom-xxbig to padding-bottom-big which is 24px diff -->
<div *ngIf="data.length === 0" class="padding-bottom-small"></div>